import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function EditIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey6', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { d: "M17.1 4.3c-.4-.4-1-.4-1.4 0L4 16v4h4L19.7 8.3c.4-.4.4-1 0-1.4l-2.6-2.6z", fill: primaryFillColor }) }));
}
//# sourceMappingURL=Edit.js.map